<template>
  <div
    class="login-page bg-gradient-to-br from-primary to-secondary min-h-screen flex items-center justify-center p-4"
  >
    <div class="card w-full max-w-sm bg-base-100 shadow-xl">
      <div class="card-body">
        <h1 class="card-title text-3xl mb-4">Login</h1>

        <form @submit.prevent="loginUser">
          <div class="form-control">
            <label class="label">
              <span class="label-text">Email</span>
            </label>
            <input
              v-model="form.email"
              type="email"
              placeholder="your@email.com"
              class="input input-bordered"
              required
            />
          </div>

          <div class="form-control mt-4">
            <label class="label">
              <span class="label-text">Password</span>
            </label>
            <input
              v-model="form.password"
              type="password"
              placeholder="••••••••"
              class="input input-bordered"
              required
            />
          </div>

          <div v-if="loginFailed" class="alert alert-error mt-4">
            <i class="fas fa-exclamation-triangle"></i>
            <span>Invalid email or password.</span>
          </div>

          <div class="form-control mt-6">
            <button type="submit" class="btn btn-primary" :disabled="!canLogin">
              Login
            </button>
          </div>
        </form>

        <div class="divider text-sm">OR</div>

        <a :href="baseURL" class="btn btn-ghost">Back to Homepage</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const form = ref({
  email: '',
  password: '',
})

const loginFailed = computed(() => store.getters.loginFailed)
const baseURL = computed(() => window.location.origin)
const canLogin = computed(() => form.value.email && form.value.password)

const loginUser = () => {
  if (canLogin.value) {
    store.dispatch('login', form.value)
  }
}
</script>

<style scoped>
.login-form {
  width: 50%;
}
</style>
